import styled from 'styled-components'

export const ItemLabel = styled.div`
    padding: 0 0 8px;
    line-height: 1.5715;
    white-space: initial;
    text-align: left;
`